'use client';

import type { ComponentProps } from 'react';
import { FormattedMessage } from 'react-intl';
import { computeMessageId } from '@/i18n/scripts/computeMessageId';

export interface SmartMessageDescriptor {
  defaultMessage: string;
  description?: string;
}

type SmartFormattedMessageProps = Omit<
  ComponentProps<typeof FormattedMessage>,
  'id' | 'defaultMessage' | 'description'
> &
  SmartMessageDescriptor;

export function SmartFormattedMessage(props: SmartFormattedMessageProps) {
  const { defaultMessage, description = '', ...rest } = props;
  const id = computeMessageId(defaultMessage, description);

  return <FormattedMessage {...rest} id={id} defaultMessage={defaultMessage} />;
}
